import { useEffect } from 'react'
import dynamic from 'next/dynamic'

import { BogoBanner } from '@mc/bogo'
import { PAGE_SOURCES, PromoExplainerModal } from '@mc/promos'

import { trackProductListViewed } from 'libs/events'
import { StickyFooter } from 'components/StickyFooter'
import {
  PageDataProvider,
  CategoryNavCarousel,
} from 'pages/categories/CategoryPage/components'
import { Navigation } from 'components/Navigation'
import { Meta } from 'pages/categories/components'
import { CategoryPageProps } from 'pages/categories/pageProps'
import { GoogleOneTap } from 'experiments/pen-3951_v2_google_email_capture/components/GoogleOneTap'

import { Hero } from './components/Hero'

const BelowTheFold = dynamic(
  () => import('./components/BelowTheFold').then((m) => m.BelowTheFold),
  { ssr: false },
)

export const AllCategoryPage = ({
  slug,
  category,
  categories,
  subcategories,
  courses,
  instructors,
  coursesOutcomes,
  subcatsCoursesOutcome,
}: CategoryPageProps) => {
  useEffect(() => {
    trackProductListViewed(category?.id)
  }, [category])

  if (!subcategories) {
    return null
  }

  return (
    <PageDataProvider
      value={{
        categories,
        slug,
        subcategories,
        category,
        courses,
        instructors,
        coursesOutcomes,
        subcatsCoursesOutcome,
      }}
    >
      <Navigation /> {/* pen-5015_v1 experiment */}
      <Meta />
      <BogoBanner className='mc-mb-2' />
      <PromoExplainerModal pageSource={PAGE_SOURCES.CATEGORY_PAGE} />
      <div className='container'>
        <div className='mc-mb-6'>
          <CategoryNavCarousel />
        </div>
        <Hero />
      </div>
      <GoogleOneTap />
      <BelowTheFold />
      <StickyFooter />
    </PageDataProvider>
  )
}
